import { Quiz } from "@/models/Quiz";

export function progress(quiz: Quiz) {
  if (!quiz || !quiz.questions) {
    return 0;
  }

  let answeredQuestions = 0;

  quiz.questions.forEach((question) => {
    let done = false;

    question.answers.forEach((answer) => {
      if (answer.selected && !done) {
        answeredQuestions++;
        done = true;
      }
    });
  });

  let progress = Math.round((answeredQuestions / quiz.questions.length) * 100);

  if (progress > 100) {
    progress = 100;
  } else if (progress < 0) {
    progress = 0;
  }

  return progress;
}
